let resolve: () => void = () => undefined;

export const userInfoReady = new Promise<void>(res => {
    resolve = res;
});

export const resolveUserInfoReady = () => resolve();
